import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { APP_CONFIGS } from '../constants'
import { AppConfigFormInput } from '../types'

const updateAppConfig = async ({ id, ...data }: AppConfigFormInput) => {
  await fetchAPI({
    method: 'put',
    path: `/app_configs/${id}`,
    data,
  })
}

export const useUpdateAppConfig = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateAppConfig, {
    onSuccess: async () => {
      await queryClient.refetchQueries([APP_CONFIGS])

      toast({
        description: t('views.admin.app_configs.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
